module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "customClass": 'heightAuto',
      "footer": false
    },
    on: {
      "close": _vm.clearSelectedItem
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Category details")]), _vm._v(" "), (_vm.getSelectedItem) ? _c('h3', [_vm._v(_vm._s(_vm.getSelectedItem.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "m-4"
  }, [_c('category-edit')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ec8acc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/CategoryView.vue
// module id = 1288
// module chunks = 0